import { AppRootState } from './store';
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { handleServerNetworkError } from "../utils/errorUtils/handleServerNetworkError"
import { AlertColor } from '@mui/material';

const slice = createSlice({
  name: 'app',
  initialState: {
    status: 'idle',
    error: null,
    color: 'error',
    initialized: false
  } as AppInitialStateType,
  reducers: {
    setAppStatusAC(state, action: PayloadAction<{ status: RequestStatusType }>) {
      state.status = action.payload.status
    },
    setAppErrorAC(state, action: PayloadAction<{ error: string | null, color: AlertColor }>) {
      state.error = action.payload.error
      state.color = action.payload.color
    }
  },
  extraReducers: builder => {
    builder.addCase(initializeAppTC.fulfilled, (state) => {
      state.initialized = true
    })
  }
})


// thunks
export const initializeAppTC = createAsyncThunk('app/init', async (_, { dispatch, getState }) => {
  const state = getState() as AppRootState
  const token = state.auth.token
  try {
    // const res = await authAPI.user(token)
    //if (res.data.resultCode === 0) {
    // console.log( 'USER RESPONSE', res)
    // dispatch(setIsLoggedInAC({ value: true })) 
    //}
    return
  } catch (error: any) {
    handleServerNetworkError(error.message, dispatch)
  }
})

export const appReducer = slice.reducer
export const { setAppErrorAC, setAppStatusAC } = slice.actions

export type AppInitialStateType = {
  status: RequestStatusType
  error: string | null
  //true if user is checked
  initialized: boolean
  color: AlertColor
}
export type RequestStatusType = 'idle' | 'loading' | 'succeeded' | 'failed'
export type SetAppErrorActionType = ReturnType<typeof setAppErrorAC>
export type SetAppStatusActionType = ReturnType<typeof setAppStatusAC>
